import { render, staticRenderFns } from "./BuyeDidModal.vue?vue&type=template&id=551ef80e&scoped=true&"
import script from "./BuyeDidModal.vue?vue&type=script&lang=js&"
export * from "./BuyeDidModal.vue?vue&type=script&lang=js&"
import style0 from "./BuyeDidModal.vue?vue&type=style&index=0&id=551ef80e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551ef80e",
  null
  
)

component.options.__file = "BuyeDidModal.vue"
export default component.exports